import { useState, FC } from 'react';
import { Button, Typography, Dialog, DialogContent, DialogTitle, DialogActions, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { PaperComponent } from 'shared/ui/draggable/Draggable';
import CloseIcon from '@mui/icons-material/Close';
import { TimekeeperService } from 'services/TimekeeperService';

interface DeletePayRuleProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    reloading: () => void;
    selected: any;
    cleanSelected: () => void;
}

const DeletePayRule: FC<DeletePayRuleProps> = ({ open, setOpen, reloading, selected, cleanSelected }) => {
    const tk = new TimekeeperService();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const DeletePayRules = async () => {
        setLoading(true);

        try {
            const response = await tk.payrules.deletePayRule(selected[0]?.id);
            console.log('response:', response);
            enqueueSnackbar(t('settings.pay_rules.alerts.delete.success'), { variant: 'success' });
            reloading();
            setOpen(false);
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('settings.pay_rules.alerts.delete.error'), { variant: 'error' });
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    const close = () => {
        cleanSelected();
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {t('settings.pay_rules.dialog.titles.delete')}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={() => close()}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <Typography variant="body1">{t('settings.pay_rules.dialog.alerts.delete.message')}</Typography>
                <ul>
                    <li>
                        <Typography variant="body1">{selected[0]?.name}</Typography>
                    </li>
                </ul>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="error" disableElevation onClick={() => close()}>
                    {t('general.buttons.cancel')}
                </Button>
                <Button variant="contained" color="primary" disableElevation onClick={() => DeletePayRules()} disabled={loading}>
                    {t('general.buttons.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { DeletePayRule };
